<template>
  <el-container style="height: 100%; display: block">
    <!-- 头部导航 -->
    <div id="head" :class="headerClass">
      <div class="center">
        <a href="/" class="router-link-active logo"></a>
        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
          <i :class="showMobileMenu ? 'el-icon-close' : 'el-icon-menu'"></i>
        </div>
        <!-- 导航菜单 -->
        <el-menu
          :default-active="activeIndex"
          :class="{'el-menu-horizontal': !isMobile, 'el-menu-vertical': isMobile}"
          :mode="isMobile ? 'vertical' : 'horizontal'"
          @select="handleSelect"
          :collapse="isCollapsed"
          v-show="!isMobile || showMobileMenu"
        style="overflow: unset">
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="2">公示查询</el-menu-item>
          <el-menu-item v-if="!isMobile" index="3">产品与服务</el-menu-item>
          <el-menu-item v-if="!isMobile" index="4">专精特新</el-menu-item>
          <el-menu-item v-if="!isMobile" index="5">新闻中心</el-menu-item>
          <el-menu-item v-if="!isMobile" index="6">关于我们</el-menu-item>
        </el-menu>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <el-main style="padding: 0;">
      <div :style="{'margin': '0 auto', 'width': '100%', 'min-height': screenHeight + 'px'}">
        <router-view />
      </div>

      <!-- 页脚 -->
      <el-footer class="foot-new">
        <div style="color: #ffffff; max-width: 1200px; margin: 30px auto; line-height: 36px; text-align: center; font-size: 14px; font-weight: normal">
          <div class="foot-xl">
            <div style="float: left; width: 100%; text-align: center;" :class="{'foot-contact': !isMobile}">
              <ul>
                <li>联系电话 13021225786</li>
                <li v-if="!isMobile">邮箱：creditgj@163.com</li>
                <li v-if="!isMobile"><span style="margin-right: 27px">地</span>址：北京市海淀区北三环西路25号2号楼106室</li>
                <li v-if="!isMobile"><span style="margin-right: 20px">Copyright © 2024 </span> 北京冠捷时速信用管理有限责任公司</li>
              </ul>
            </div>
          </div>
        </div>
      </el-footer>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      screenHeight: 500,
      loginFlag: 0,
      activeIndex: '0',
      headerClass: '',
      scrollY: 0,
      isMobile: false,
      showMobileMenu: false,
      isCollapsed: false
    }
  },
  created () {
    this.screenHeight = window.innerHeight - 350
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile () {
      this.isMobile = window.innerWidth <= 768
      this.isCollapsed = this.isMobile
      if (!this.isMobile) {
        this.showMobileMenu = false
      }
    },
    handleScroll () {
      this.scrollY = window.scrollY
      if (this.scrollY > 50) {
        this.headerClass = 'active'
      } else {
        this.headerClass = ''
      }
    },
    handleSelect (index, indexPath, route) {
      if (this.isMobile) {
        this.showMobileMenu = false
        if (index === '1') {
          this.$router.push('/')
        } else if (index === '2') {
          this.$router.push('/searchCreditH5')
        } else if (index === '5') {
          this.$router.push('/newslist')
        }
      } else {
        if (index === '1') {
          this.$router.push('/')
        } else if (index === '2') {
          this.$router.push('/searchCredit')
        } else if (index === '5') {
          this.$router.push('/newslist')
        }
      }
    },
    onHome () {
      this.$router.push('/')
    },
    onConsole () {
      this.$router.push({ name: 'Console' })
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #ffffff;
  border: 0px;
  background: #00000000;
}

.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: #ffffff;
  border: 0px;
}

.el-menu-item {
  height: 64px !important;
  line-height: 64px !important;
  border: 0px !important;
}

/* 头部样式 */
#head.active {
  transition: all .7s linear;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}

#head {
  width: 100%;
  height: 64px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  border-bottom: 1px solid rgba(229, 229, 229, .3);
}

#head:hover,
#head.active {
  transition: all .7s linear;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}

#head .center {
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  height: 64px;
  /*align-items: center;*/
}

#head:hover .logo,
#head.active .logo {
  background-image: url(../../assets/img/logogj_black.png);
}

#head .logo {
  float: left;
  background: url(../../assets/img/logogj.png) no-repeat;
  width: 121px;
  height: 45px;
  margin-top: 10px;
  background-size: cover;
  background-position: center;
  z-index: 10;
}

#head:hover .el-menu,
#head.active .el-menu {
  background-color: transparent;
}

#head .el-menu {
  background-color: transparent;
  border-bottom: none;
  height: 64px;
  /*flex-grow: 1;*/
  justify-content: flex-end;
}

#head:hover .el-menu .el-menu-item,
#head.active .el-menu .el-menu-item {
  color: #333;
}

#head .el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  color: #1E88E5 !important;
}

.el-menu--horizontal .el-menu-item {
  color: white;
  font-size: 16px;
  font-weight: 500;
  height: 50px;
  line-height: 50px;
}

.el-menu--horizontal .el-menu-item:hover {
  color: #ffd04b;
}

/* 垂直模式下的样式 */
.el-menu-vertical .el-menu-item {
  background: #ffffff;
  color: white;
  font-size: 16px;
  font-weight: 500;
  height: 30px;
  line-height: 30px;
  width: 150px;
  margin-left: 200px;
  float: right;
  text-align: center;
}
.el-menu-vertical .el-menu-item:hover {
  background: #ffffff;
  color: white;
  font-size: 16px;
  font-weight: 500;
  height: 30px;
  line-height: 30px;
  width: 150px;
  margin-left: 200px;
  float: right;
  text-align: center;
}
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background-color: #46a6ff;
  color: #46a6ff;
}

.el-menu--horizontal>.el-menu-item.is-active {
  color: #ffffff;
}

/* 移动端菜单按钮 */

.mobile-menu-btn {
  display: none;
  color: #cf6602;
  line-height: 55px;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
}

/* 页脚样式 */
.foot-xl {
  width: 95%;
  max-width: 1200px;
  margin: auto;
  text-align: center;
}

.foot-xl ul {
  width: 100%;
  margin: auto;
  list-style-type: none;
  padding: 0;
}

.foot-xl li {
  text-align: left;
  margin-bottom: 10px;
}
.foot-new{
  padding: 0; background-color: #5a5e66; overflow: hidden; height: 260px !important;
}
/* 响应式设计 */
@media (max-width: 768px) {
  .foot-new{
  padding: 0; background-color: #5a5e66; overflow: hidden; height: 60px !important;
}
  /* 头部 */
  .mobile-menu-btn {
    display: block;
  }
    .el-footer{
      position: fixed;
      bottom: 0;
      padding: 0px;
      width: 100%;
    }
  #head .el-menu {
    position: absolute;
    top: 64px;
    left: 0;
    width: 100%;
    background-color: #fff;
    flex-direction: column;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-menu--horizontal .el-menu-item {
    color: #333;
    text-align: center;
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: 1px solid #f0f0f0;
  }

  /* 页脚 */
  .foot-xl {
    width: 90%;
  }

  .foot-xl ul {
    text-align: center;
  }

  .foot-xl li {
    text-align: center;
    margin-bottom: 10px;
  }

  .foot-xl li span {
    display: inline-block;
    width: 50px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  #head .center {
    width: 98%;
  }

  .el-menu--horizontal .el-menu-item {
    font-size: 14px;
    padding: 0 10px;
  }
}
</style>

<style>
/* 全局样式 */
.el-menu--horizontal .el-submenu .el-submenu__title {
  line-height: 50px;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

.el-menu--horizontal .el-submenu:hover .el-submenu__title {
  line-height: 50px;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

.el-menu--horizontal > .el-submenu:focus .el-submenu__title,
.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  color: #ffffff;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/computer/headandfoot.vue